
import { Globe, Moon, Palette, Sun } from 'lucide-react';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { painelSelectContentClass } from '@/components/painel/painel-styles';
import { painelSelectTriggerClass } from '@/components/painel/cms/painel-form';
import { cn } from '@/lib/utils';
import { AccountSettingsCard } from './account-settings-shared';

type AppearanceCardProps = {
  delay?: number;
};

export function AppearanceCard({ delay = 0 }: AppearanceCardProps) {
  return (
    <AccountSettingsCard
      title="Aparência"
      description="Personalize o visual do painel — opções em desenvolvimento."
      icon={Palette}
      accentClass="bg-violet-500/15 text-violet-300 ring-violet-400/25"
      delay={delay}
    >
      <div className="grid gap-8 md:grid-cols-2">
        <fieldset className="space-y-4">
          <legend className="font-poppins text-sm font-medium text-white">Tema</legend>
          <div className="space-y-3">
            <label
              className={cn(
                'flex cursor-pointer items-center gap-3 rounded-xl border border-sky-400/30 bg-sky-500/10 p-4',
                'transition-colors hover:border-sky-400/45'
              )}
            >
              <input
                type="radio"
                name="account-theme"
                value="dark"
                defaultChecked
                className="h-4 w-4 border-white/20 bg-white/10 text-sky-500 focus:ring-sky-400/30"
              />
              <Moon className="h-4 w-4 text-sky-300" aria-hidden />
              <span className="font-inter text-sm text-white">Escuro</span>
            </label>

            <label
              className={cn(
                'flex cursor-not-allowed items-center gap-3 rounded-xl border border-white/[0.07] bg-white/[0.02] p-4 opacity-60'
              )}
            >
              <input
                type="radio"
                name="account-theme"
                value="light"
                disabled
                className="h-4 w-4"
              />
              <Sun className="h-4 w-4 text-slate-500" aria-hidden />
              <span className="font-inter text-sm text-slate-400">
                Claro <span className="text-slate-500">(Em breve)</span>
              </span>
            </label>
          </div>
        </fieldset>

        <div className="space-y-4">
          <Label className="font-poppins text-sm font-medium text-white">Idioma</Label>
          <Select defaultValue="pt-BR" disabled>
            <SelectTrigger className={painelSelectTriggerClass}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent className={painelSelectContentClass}>
              <SelectItem value="pt-BR" className="focus:bg-white/10 focus:text-white">
                Português (Brasil)
              </SelectItem>
              <SelectItem value="en" disabled className="focus:bg-white/10 focus:text-white">
                Inglês (Em breve)
              </SelectItem>
            </SelectContent>
          </Select>
          <p className="flex items-center gap-1.5 font-inter text-xs text-slate-500">
            <Globe className="h-3.5 w-3.5" aria-hidden />
            Mais idiomas serão adicionados em atualizações futuras.
          </p>
        </div>
      </div>
    </AccountSettingsCard>
  );
}
